import { Check } from '@phosphor-icons/react';
import clsx from 'clsx';
import { StepToStepCommonProps } from 'types';
import { lineDashed, lineGreen } from 'utils/importFile';

const StepToStepCommon: React.FC<StepToStepCommonProps> = ({ current, steps, className = '' }) => {
  return (
    <div className={`flex items-center justify-center py-3 ${className}`}>
      {steps.map((step, index) => {
        const isCompleted = index < current || step.isCompleted;
        const isActive = index === current;
        return (
          <div key={index} className='flex items-center'>
            <div
              className={clsx(
                'w-[52px] h-10 flex items-center justify-center rounded-full',
                isCompleted
                  ? 'bg-[var(--sematicSuccessColor500)] text-white'
                  : isActive
                    ? 'bg-[var(--primaryColor500)] text-white'
                    : 'bg-white text-gray-500',
              )}
            >
              {isCompleted ? <Check size={20} weight='bold' /> : step.icon}
            </div>
            <span
              className={clsx(
                'ml-3',
                isCompleted
                  ? 'text-[var(--sematicSuccessColor500)] font-semibold'
                  : isActive
                    ? 'text-[var(--primaryColor500)] font-bold'
                    : 'text-gray-500 font-medium',
              )}
            >
              {step.title}
            </span>
            {index < steps.length - 1 && (
              <img src={index < current ? lineGreen : lineDashed} alt='icon dashed line' className='mx-3 w-[60px]' />
            )}
          </div>
        );
      })}
    </div>
  );
};
export default StepToStepCommon;
